<template>
  <div class="off-day-wrap">
    <div class="banner">
      <img src="../../assets/images/winter/second/banner.png" />
    </div>
    <div class="main-content">
      <div class="today-math">
        <div class="title">今日赛程</div>
        <p class="match-node">休赛日</p>
        <p class="time">1月22日~1月29日</p>
      </div>
      <ul class="three-module">
        <li>
          <a class="module-entry">
            <img src="../../assets/images/winter/second/rank.png" />
            <p class="module-title">排行榜</p>
          </a>
        </li>
        <li>
          <a class="module-entry">
            <img src="../../assets/images/winter/second/myTeam.png" />
            <p class="module-title">我的战队</p>
          </a>
        </li>
        <li>
          <a class="module-entry">
            <img src="../../assets/images/winter/second/allMember.png" />
            <p class="module-title">全部学员</p>
          </a>
        </li>
      </ul>
      <div class="war-situation">
        <ul class="header-ul">
          <li>今日战况</li>
          <li>昨日战绩</li>
        </ul>
        <div class="record-box">
          <img class="rank-first" src="../../assets/images/winter/second/rankFirst.png" />
          <div class="team-record">
            <div class="study-time">
              <span>2023-1-12</span>
            </div>
            <p class="team-name">学霸们四处冲冲冲</p>
            <div class="belong-group">青龙1组</div>
            <ul class="record-detail">
              <li class="detail-item">
                <div>
                  <p class="num">48</p>
                  <p class="label">PK局数</p>
                </div>
                <div>
                  <p class="num">8</p>
                  <p class="label">PK人数</p>
                </div>
              </li>
              <li class="detail-item">
                <div>
                  <p class="num">70%</p>
                  <p class="label">PK局数</p>
                </div>
                <div>
                  <p class="num">2400</p>
                  <p class="label">单日奖杯数</p>
                </div>
              </li>
              <li class="line"></li>
            </ul>
            <div class="share-btn">查看海报</div>
          </div>
        </div>
      </div>
      <div class="yesterday-situation">
        <div class="mvp-icon">
          <img src="../../assets/images/winter/second/yesterdayMvp.png" />
        </div>
        <div class="team">
          <p class="title">战队</p>
          <div class="header">
            <p class="header-text">单日奖杯数最多</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '青龙',
      result: {
        '青龙战区': [
          [
            [{ name: '青龙1组', rank: '第1名' }, { name: '青龙人气', rank: '第2名' }],
            [{ name: '青龙2组', rank: '第1名' }, { name: '青龙人气', rank: '第4名' }],
          ],
          [
            [{ name: '青龙3组', rank: '第1名' }, { name: '青龙6组', rank: '第2名' }],
            [{ name: '青龙4组', rank: '第1名' }, { name: '青龙5组', rank: '第2名' }],
          ],
          [
            [{ name: '青龙5组', rank: '第1名' }, { name: '青龙4组', rank: '第2名' }],
            [{ name: '青龙6组', rank: '第1名' }, { name: '青龙3组', rank: '第2名' }],
          ],
          [
            [{ name: '青龙人气', rank: '第1名' }, { name: '青龙2组', rank: '第2名' }],
            [{ name: '青龙人气', rank: '第3名' }, { name: '青龙1组', rank: '第2名' }],
          ],
        ],
        '白虎战区': [
          [
            [{ name: '白虎1组', rank: '第1名' }, { name: '白虎人气', rank: '第2名' }],
            [{ name: '白虎2组', rank: '第1名' }, { name: '白虎人气', rank: '第4名' }],
          ],
          [
            [{ name: '白虎3组', rank: '第1名' }, { name: '白虎6组', rank: '第2名' }],
            [{ name: '白虎4组', rank: '第1名' }, { name: '白虎5组', rank: '第2名' }],
          ],
          [
            [{ name: '白虎5组', rank: '第1名' }, { name: '白虎4组', rank: '第2名' }],
            [{ name: '白虎6组', rank: '第1名' }, { name: '白虎3组', rank: '第2名' }],
          ],
          [
            [{ name: '白虎人气', rank: '第1名' }, { name: '白虎2组', rank: '第2名' }],
            [{ name: '白虎人气', rank: '第3名' }, { name: '白虎1组', rank: '第2名' }],
          ],
        ],
        '朱雀战区': [
          [
            [{ name: '朱雀1组', rank: '第1名' }, { name: '朱雀人气', rank: '第2名' }],
            [{ name: '朱雀2组', rank: '第1名' }, { name: '朱雀人气', rank: '第4名' }],
          ],
          [
            [{ name: '朱雀3组', rank: '第1名' }, { name: '朱雀6组', rank: '第2名' }],
            [{ name: '朱雀4组', rank: '第1名' }, { name: '朱雀5组', rank: '第2名' }],
          ],
          [
            [{ name: '朱雀5组', rank: '第1名' }, { name: '朱雀4组', rank: '第2名' }],
            [{ name: '朱雀6组', rank: '第1名' }, { name: '朱雀3组', rank: '第2名' }],
          ],
          [
            [{ name: '朱雀人气', rank: '第1名' }, { name: '朱雀2组', rank: '第2名' }],
            [{ name: '朱雀人气', rank: '第3名' }, { name: '朱雀1组', rank: '第2名' }],
          ],
        ],
        '玄武战区': [
          [
            [{ name: '玄武1组', rank: '第1名' }, { name: '玄武人气', rank: '第2名' }],
            [{ name: '玄武2组', rank: '第1名' }, { name: '玄武人气', rank: '第4名' }],
          ],
          [
            [{ name: '玄武3组', rank: '第1名' }, { name: '玄武6组', rank: '第2名' }],
            [{ name: '玄武4组', rank: '第1名' }, { name: '玄武5组', rank: '第2名' }],
          ],
          [
            [{ name: '玄武5组', rank: '第1名' }, { name: '玄武4组', rank: '第2名' }],
            [{ name: '玄武6组', rank: '第1名' }, { name: '玄武3组', rank: '第2名' }],
          ],
          [
            [{ name: '玄武人气', rank: '第1名' }, { name: '玄武2组', rank: '第2名' }],
            [{ name: '玄武人气', rank: '第3名' }, { name: '玄武1组', rank: '第2名' }],
          ],
        ],
      }

    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      const { name, result } = this;
      Object.entries(result).map(([key, val]) => {
        let w = key.includes(name) 
        if(w){
          console.log(val)
        }
      })
    }
  }
}
</script>

<style lang="less">
#app {
  height: 100%;
}

.off-day-wrap {
  height: 100%;
  background: linear-gradient(180deg, #00236D 0%, #001D46 100%);
  overflow-y: auto;

  .banner {
    img {
      width: 100%;
    }
  }

  .main-content {
    position: relative;
    top: -120px;

    .today-math {
      width: 622px;
      height: 220px;
      margin: 0 auto;
      background: #FFFFFF;
      border-radius: 8px;

      .title {
        position: relative;
        width: 192px;
        height: 52px;
        top: 16px;
        background: #E4F1FD;
        border-radius: 0px 200px 200px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #58ABF6;
      }

      .match-node {
        margin-top: 10px;
        font-size: 48px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #323232;
        text-align: center;
      }

      .time {
        margin-top: 18px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #323232;
        text-align: center;
      }
    }

    .three-module {
      width: 622px;
      display: flex;
      margin: 40px auto 0;
      justify-content: space-around;

      li {
        .module-entry {
          img {
            width: 112px;
            height: 112px;
          }

          .module-title {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
          }
        }
      }
    }

    .war-situation {
      margin-top: 30px;

      .header-ul {
        display: flex;
        justify-content: center;

        li {
          width: 200px;
          height: 60px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(88, 175, 255, 1);
        }
      }

      .record-box {
        margin: 0 48px;
        background: linear-gradient(180deg, #0077CA 0%, #00429A 100%);
        border: 12px solid #3C7CD4;
        border-radius: 12px;

        .rank-first {
          width: 100%;
        }

        .team-record {
          padding-bottom: 32px;
          background-color: #FFFFFF;

          .study-time {
            padding-top: 14px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #323232;
            text-align: center;
          }

          .team-name {
            margin-top: 8px;
            font-size: 34px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #323232;
            text-align: center;
          }

          .belong-group {
            width: 208px;
            height: 46px;
            margin: 12px auto 0;
            background: rgba(88, 171, 246, 0.16);
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #619CF5;
          }

          .record-detail {
            position: relative;
            width: 414px;
            margin: 0 auto;

            .detail-item {
              display: flex;
              justify-content: space-around;
              text-align: center;
              padding: 24px 0;
              border-bottom: 2px solid #DEE5F0;

              .num {
                font-size: 48px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #323232;
              }

              .label {
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #68707D;
              }
            }

            .line {
              position: absolute;
              width: 2px;
              height: 172px;
              left: 50%;
              top: 68px;
              background-color: #DEE5F0;
            }
          }

          .share-btn {
            width: 312px;
            height: 64px;
            margin: 32px auto 0;
            background: linear-gradient(90deg, #4572F7 0%, #FF5AA8 100%);
            border-radius: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }
    }

    .yesterday-situation {
      .mvp-icon {
        img {
          width: 100%;
        }
      }

      .team {
        width: 622px;
        margin: 0 auto;
        background: #FFFFFF;
        border-radius: 8px;

        .title {
          padding: 24px 0 8px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #58ABF6;
          text-align: center;
        }

        .header {
          width: 550px;
          height: 70px;
          margin: 0 auto;
          background: url('../../assets/images/winter/second/titleBg.png') no-repeat;
          background-size: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .header-text {
            text-align: center;
            font-size: 40px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
</style>